// removed by extract-text-webpack-plugin
module.exports = {"block":"_2sLCCy-EEdRjGjUL8ZnN3l","caption":"_1maxP6NsvJWz8oykP33PhD","carousel":"tOB96PKwJfX4BvEY9cahM","dummy":"_2Obn2U9zSt7ivWOVM5a_O0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageBlock/ImageBlock.module.scss
// module id = 778
// module chunks = 0